import React, { useEffect, useState } from "react";
import { Row, Col, Button, Modal, Typography } from "antd";
import { COLORS } from "~constants";

import circleCheck from "~assets/general/circleCheck.png";
import dangerCircle from "~assets/general/dangerCircle.png";

import "./ColorfulModal.css";
const BeautifulModal = ({
  visible,
  rightOnClickHandler = () => {},
  leftOnClickHandler = () => {},
  cancelHandler = () => {},
  state,
}) => {
  const { Text } = Typography;
  const [isVisible, setisVisible] = useState(visible);
  const [dangerConfirmation, setDangerConfirmation] = useState(false);

  function dangerConfirmationFun() {
    setDangerConfirmation((prev) => !prev);
    /*TODO: reset fields functionality */
    if (dangerConfirmation === true) {
      console.log("Include Reset Fields function here");
    }
  }

  useEffect(() => {
    setisVisible(visible);
  }, [visible]);
  return (
    <>
      <Modal
        visible={isVisible}
        footer={false}
        width={400}
        onCancel={() => {
          setisVisible(false);
          cancelHandler();
        }}
      >
        <Row style={{ marginTop: "25px" }}>
          <Col span={12}>
            <img
              alt="modal-icon"
              style={{
                display: "flex",
                justifyContent: "center",
                width: "70%",
                paddingBottom: "20px",
              }}
              src={
                state === "success"
                  ? circleCheck
                  : state === "danger"
                  ? dangerCircle
                  : null
              }
            />
          </Col>
          <Col span={12}>
            <h2>
              <Text
                type={
                  state === "success"
                    ? "success"
                    : state === "danger"
                    ? "secondary"
                    : "secondary"
                }
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                {state === "success"
                  ? "Successfully\nSaved!"
                  : state === "danger"
                  ? "Your report is\nnot yet saved."
                  : "secondary"}
              </Text>

              <Text
                type={state}
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <strong>
                  {state === "success"
                    ? ""
                    : state === "danger"
                    ? "Are you sure you want to exit"
                    : state === "danger" && dangerConfirmation === true
                    ? "Are you sure you want to reset fields"
                    : "secondary"}
                </strong>
              </Text>
            </h2>
          </Col>
        </Row>
        <Row
          style={{ marginTop: 20, display: "flex", justifyContent: "center" }}
        >
          <Col span={12}>
            <Button
              onClick={() => leftOnClickHandler()}
              size="large"
              style={{ backgroundColor: COLORS.blue1 }}
            >
              <Text strong style={{ color: "white" }}>
                {state === "success" ? "VIEW" : "YES"}
              </Text>
            </Button>
          </Col>
          <Col span={5} style={{ justifyContent: "flex-end", display: "flex" }}>
            {/*TODO: Please fix submit functionality when on modal */}
            <Button
              size="large"
              htmlType="submit"
              style={{ backgroundColor: COLORS.orange }}
              onClick={() => rightOnClickHandler()}
            >
              <Text strong style={{ color: "white" }}>
                {state === "success" ? "ADD REPORT" : "NO"}
              </Text>
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default BeautifulModal;
